import { commonMessages } from "@/messages/common";

export const layoutMessages = {
  brand: commonMessages.brand,
  sidebar: {
    ariaLabel: "Admin navigation",
    brandAriaLabel: "NetShield Admin Portal — go to Customers",
    brandLabel: "Admin",
    sessionLabel: "Logged in as",
    sections: {
      navigate: "Navigate",
      system: "System",
    },
    nav: {
      customers: "Customers",
      accountManagers: "Account managers",
      auditLog: "Audit log",
      settings: "Settings",
    },
  },
  topBar: {
    breadcrumbAriaLabel: "Breadcrumb",
    adminPortal: "Admin Portal",
    customers: "Customers",
    accountManagers: "Account managers",
    onboardingQueue: "Onboarding queue",
    auditLog: "Audit log",
    settings: "Settings",
    admin: "Admin",
    addNew: "Add new",
    newCustomer: "New customer",
    stepOf: (step: number) => `Step ${step} of 4`,
    createdCustomerStep: (step: number) => `Step ${step} of 4`,
    customerFallback: "Customer",
  },
} as const;
